import {fetch} from "utils/dataAccess";

export default async function deleteAll(memberId) {
    const response = await fetch(`/notifications/delete_all?member=${memberId}`);

    if (!response.ok) throw new Error('Failed to delete all notifications');

    return await response.json();
}
